export enum ObstacleType {
	Bush = 'Bush',
	Tree = 'Tree',
	Rock = 'Rock',
	Block = 'Block',
	Box = 'Box',
	Camo = 'Camo',
}
